/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { NewProjectChannel } from '../models/new-project-channel';
import { ProjectChannel } from '../models/project-channel';
import { ProjectChannelWithRelations } from '../models/project-channel-with-relations';

@Injectable({
  providedIn: 'root',
})
export class ProjectChannelControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation projectChannelControllerFindByApiKey
   */
  static readonly ProjectChannelControllerFindByApiKeyPath = '/api-key/project-channels';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByApiKey()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByApiKey$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<ProjectChannelWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectChannelControllerService.ProjectChannelControllerFindByApiKeyPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ProjectChannelWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findByApiKey$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByApiKey(params?: {
    filter?: any;
  }): Observable<Array<ProjectChannelWithRelations>> {

    return this.findByApiKey$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ProjectChannelWithRelations>>) => r.body as Array<ProjectChannelWithRelations>)
    );
  }

  /**
   * Path part for operation projectChannelControllerCreateByApiKey
   */
  static readonly ProjectChannelControllerCreateByApiKeyPath = '/api-key/project-channels';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createByApiKey()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createByApiKey$Response(params?: {
    body?: NewProjectChannel
  }): Observable<StrictHttpResponse<ProjectChannel>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectChannelControllerService.ProjectChannelControllerCreateByApiKeyPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectChannel>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createByApiKey$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createByApiKey(params?: {
    body?: NewProjectChannel
  }): Observable<ProjectChannel> {

    return this.createByApiKey$Response(params).pipe(
      map((r: StrictHttpResponse<ProjectChannel>) => r.body as ProjectChannel)
    );
  }

  /**
   * Path part for operation projectChannelControllerFind
   */
  static readonly ProjectChannelControllerFindPath = '/project-channels';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<ProjectChannelWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectChannelControllerService.ProjectChannelControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ProjectChannelWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<ProjectChannelWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ProjectChannelWithRelations>>) => r.body as Array<ProjectChannelWithRelations>)
    );
  }

  /**
   * Path part for operation projectChannelControllerCreate
   */
  static readonly ProjectChannelControllerCreatePath = '/project-channels';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewProjectChannel
  }): Observable<StrictHttpResponse<ProjectChannel>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectChannelControllerService.ProjectChannelControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectChannel>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewProjectChannel
  }): Observable<ProjectChannel> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<ProjectChannel>) => r.body as ProjectChannel)
    );
  }

}
